import React, { RefObject, useEffect, useMemo, useRef } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
// import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/contactDetailsFBBStyle';
import { MenuItem, Select, TextField, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyles = makeStyles(style);
const getValue = (event: React.FormEvent<HTMLInputElement>) => (event.target as HTMLInputElement).value;

const ContactDetailsTabFBB = (
	props: types.services.fixed.IContactDetailsFiberPro & {
		onChange: (name: keyof types.services.fixed.IContactDetailsFiberPro, value: string | boolean) => void;
		setNextStepDisabled: (nextStepDisabled: boolean) => void;
	}
) => {
	// this component get focussed - for accessibility
	const ref: RefObject<HTMLDivElement> = useRef(null);
	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);
	const fiberProLabels = useSelector(getFiberProLabels);
	const { setNextStepDisabled, reqName, contactNo, bestTime } = props;

	useEffect(() => {
		setNextStepDisabled(true);
	}, [setNextStepDisabled]);

	useEffect(() => {
		setNextStepDisabled(
			!([reqName, contactNo, bestTime].every((value) => value.trim().length > 0) && contactNo.trim().length > 7)
		);
	}, [setNextStepDisabled, reqName, contactNo, bestTime]);

	const classes = useStyles();
	return (
		<div ref={ref}>
			<GridContainer justify="flex-start">
				<GridItem xs={8} md={8} lg={8} justify="flex-start">
					<GridContainer>
						<GridItem xs={12} md={12}>
							<TextField
								onChange={(event: any) => {
									props.onChange('reqName', event.target.value);
								}}
								value={props.reqName}
								fullWidth
								variant="outlined"
								inputProps={{ maxLength: 80, 'data-testid': 'reqName' }}
								placeholder={fiberProLabels.reqName}
							/>
						</GridItem>
						<GridItem xs={12} md={12} className={classes.gridMargin}>
							<TextField
								onChange={(event: any) => {
									props.onChange('contactNo', getValue(event).replace(/[^0-9]$/, ''));
								}}
								inputProps={{ maxLength: 8, 'data-testid': 'contactNumber' }}
								value={props.contactNo}
								fullWidth
								variant="outlined"
								placeholder={fiberProLabels.contactNo}
							/>
						</GridItem>
						<GridItem xs={12} md={12} className={classes.gridMargin}>
							<Select
								labelId="bestTime-select-small-label"
								className={classes.bestTimeSelect}
								inputProps={{ 'data-testid': 'bestTimeSelect' }}
								value={props.bestTime}
								displayEmpty
								renderValue={(selected: any) => {
									if (selected.length === 0) {
										return (
											<span className={classes.bestTimeSelectPlaceholder}>
												{fiberProLabels.bestTime}
											</span>
										);
									}

									return selected;
								}}
								variant="outlined"
								label={fiberProLabels.bestTime}
								onChange={(event: any) => props.onChange('bestTime', event.target.value)}
							>
								{[fiberProLabels.morning, fiberProLabels.afternoon, fiberProLabels.evening].map(
									(text, index) => (
										<MenuItem value={text} key={`${text}${index}`}>
											{text}
										</MenuItem>
									)
								)}
							</Select>
						</GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
		</div>
	);
};

export default ContactDetailsTabFBB;
